import { useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import ButtonBase from "@material-ui/core/ButtonBase";
import { EditAnnouncement } from "../modals/EditAnnouncement";
import moment from "moment";

interface AnnouncementItemProps {
  announcements: any[];
  branch: number;
  onItemChange: () => void;
}

const useStyles = makeStyles((theme) => ({
  itemsWrapper: {
    position: "relative",
    width: "80%",
    height: 210,


    borderRadius: 4,
    border: "1px solid #e1e4e8",
    marginRight: 20,
    marginBottom: 20,
    marginTop: 10,

    "& .overlay": {
      position: "absolute",
      top: 0,
      left: 0,

      height: "100%",
      width: "100%",
      backgroundColor: "transparent",
    },
  },

  title: {
    fontSize: 14,
    fontWeight: 500,
    textAlign: "left",
    fontFamily: "Lato",
    color: "#4527a0",
    marginLeft: 5,
    display: "-webkit-box",
    overflow: "hidden",
    "-webkit-line-clamp": 1,
    "-webkit-box-orient": "vertical",
  },

  description: {
    fontSize: 12,
    fontWeight: 300,
    textAlign: "justify",
    margin: 5,
    padding: 0,
    height: "20%",
  },
  descriptionPar: {
    height: "100%",
    display: "-webkit-box",
    overflow: "hidden",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
  },

  makeStylesTitle40: {
    fontSize: 20,
    fontWeight: 500,
  },

  date: {
    fontSize: 10,
    fontWeight: 400,
    color: "black",
    marginBottom: 5,
    marginTop: 10,
    marginLeft: 10,
    textAlign: "left",
  },

  image: {
    textAlign: "center",
    height: 60,
    width: "80%",
    marginRight: "auto",
    marginLeft: "auto",
    marginTop: 5,
    marginBottom: 5,
    display: "block",
  },
  avatar: {
    width: 24,
    height: 24,
    borderRadius: 40,
    marginRight: 10,
  },
  subButton: {
    textTransform: "none",
    fontSize: 10,
    padding: 2,
    margin: 2,
    width: 35,
  },
  subButtonRed: {
    textTransform: "none",
    backgroundColor: "red",
    color: "white",
    fontSize: 10,
    padding: 2,
    margin: 2,
    width: 35,
  },
  colunmContainer:{
    paddingLeft: 10,
    textAlign: "center",
  },
  "subButtonRed:hover": {
    opacity: 80,
  },
  subButtonBar: {
    textAlign: "center",
  },
  p: {
    height: "100%",
  },
}));

export const AnnouncementItem = (props: AnnouncementItemProps) => {
  const classes = useStyles();
  const [editModalOpened, setEditModalOpened] = useState(false);
  const [announcementId, setAnnouncementId] = useState(null);
  const { branch } = props;
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  const toggleEditModal = () => {
    setEditModalOpened(!editModalOpened);
    if (editModalOpened) {
      props.onItemChange();
    }
  };
  const handleClick = (e, data) => {
    setAnnouncementId(data.id);
    setSelectedAnnouncement(data);
    toggleEditModal();
  };

  return (
    <>
      {editModalOpened && (
        <EditAnnouncement
          closeCallback={toggleEditModal}
          isOpened={editModalOpened}
          branchId={branch}
          announceId={announcementId}
          announce={selectedAnnouncement}
        />
      )}
      <Grid className={classes.colunmContainer} container item xs={12} sm={12} lg={12}>
        {props.announcements.map((entry) => (
          <Grid container item xs={12} sm={6} lg={3} >
            <Box component="div" className={classes.itemsWrapper}>
              <Box className="avatarWrapper">
                <div>
                  <img
                    className={classes.image}
                    alt="avatar"
                    src={
                      entry.images.length == 0
                        ? process.env.PUBLIC_URL + "/panda.jpg"
                        : entry.images[0]
                    }
                  />
                </div>

                <div className={classes.title}>
                  <span className={classes.title}>{entry.title}</span>
                </div>
              </Box>
              <Box className={classes.date}>
                <span className="endDate">
                  {entry.start_date} To {entry.end_date}{" "}
                </span>
                <br />
              </Box>
              <Box className={classes.description}>
                <p className={classes.descriptionPar}>{entry.description}</p>
              </Box>
              {entry.start_date > moment().format("YYYY-MM-DD HH:mm:ss") &&
                <Box className={classes.subButtonBar}>
                  <ButtonBase>
                    <Button
                      color="secondary"
                      variant="contained"
                      className={classes.subButton}
                      value={entry.id}
                      onClick={(e) => handleClick(e, entry)}
                    >
                      Edit
                    </Button>

                    <Button
                      color="default"
                      variant="contained"
                      className={classes.subButtonRed}
                    >
                      Delete
                    </Button>
                  </ButtonBase>
                </Box>
              }
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
